import React from 'react';
import { useParams } from 'react-router-dom';

import { useGetProductGroupById } from '@occc-app/dataAccessLayer/productGroup/queries';
import { useChainId } from '@occc-app/Chain/hooks';

import ProductGroupDetailsPage from './ProductGroupDetailsPage';

const ProductGroupDetailsPageContainer: React.FC = () => {
  const chainId = useChainId();
  const { id: productGroupId = '' } = useParams<{ id: string }>();
  const { loading, error, data } = useGetProductGroupById(productGroupId, chainId);

  return <ProductGroupDetailsPage loading={loading} error={error} productGroup={data} />;
};

export default ProductGroupDetailsPageContainer;
